import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import SEO from '../../components/SEO/SEO';
import './About.css';

function About() {
  const { t } = useTranslation();

  return (
    <div className="about">
      <SEO
        title="About Unimar — 40+ Years of Boat Manufacturing"
        description="Learn about Unimar's history, mission, and vision. Founded from Uniplast's 40-year legacy, Unimar designs and builds CE certified fiberglass boats in North Macedonia for European and Balkan markets."
        url="/about"
        image="/unimar-factory-north-macedonia.webp"
      />
      <Header />

      {/* Hero Image */}
      <section className="about-hero">
        <div className="about-hero__image-wrapper">
          <img
            src="/unimar-factory-north-macedonia.webp"
            alt="Unimar manufacturing facility"
            className="about-hero__image"
          />
        </div>
        <div className="about-hero__overlay" />
      </section>

      {/* Page Title */}
      <div className="about-page-title">
        <h1>{t('aboutPage.pageTitle')}</h1>
      </div>

      {/* Container 1: Text Left, Image Right */}
      <section className="about-container about-container--text-first">
        <div className="about-container__text">
          <p>{t('aboutPage.container1.text1')}</p>
        </div>
        <div className="about-container__arrow-horizontal">
          <img src="/arrow.webp" alt="Arrow pointing right" />
        </div>
        <div className="about-container__image">
          <img src="/unimar-about-heritage.webp" alt="UniMar Design" />
        </div>
      </section>
      <div className="about-container__arrow-vertical">
        <img src="/arrow.webp" alt="Arrow pointing down" />
      </div>

      {/* Container 2: Image Left, Text Right */}
      <section className="about-container about-container--image-first">
        <div className="about-container__image">
          <img src="/unimar-about-journey.webp" alt="UniMar Development" />
        </div>
        <div className="about-container__arrow-horizontal about-container__arrow-horizontal--left">
          <img src="/arrow.webp" alt="Arrow pointing left" />
        </div>
        <div className="about-container__text">
          <p>{t('aboutPage.container2.text1')}</p>
          <p>{t('aboutPage.container2.text2')}</p>
        </div>
      </section>
      <div className="about-container__arrow-vertical about-container__arrow-vertical--left">
        <img src="/arrow.webp" alt="Arrow pointing down" />
      </div>

      {/* Container 3: Text Left, Image Right */}
      <section className="about-container about-container--text-first">
        <div className="about-container__text">
          <p>{t('aboutPage.container3.text1')}</p>
          <p>{t('aboutPage.container3.text2')}</p>
        </div>
        <div className="about-container__arrow-horizontal">
          <img src="/arrow.webp" alt="Arrow pointing right" />
        </div>
        <div className="about-container__image">
          <div className="about-container__image-labeled">
            <span className="about-container__image-label">{t('aboutPage.container3.imageLabel')}</span>
            <img src="/unimar-about-engineering.webp" alt="UniMar Boat Design" />
          </div>
        </div>
      </section>
      <div className="about-container__arrow-vertical about-container__arrow-vertical--right">
        <img src="/arrow.webp" alt="Arrow pointing down" />
      </div>

      {/* Container 4: Full Width Text */}
      <section className="about-container-full">
        <div className="about-container-full__text">
          <p>{t('aboutPage.container4.text1')}</p>
          <p>{t('aboutPage.container4.text2')}</p>
        </div>
      </section>

      {/* Mission Container */}
      <section className="about-mission-container">
        <div className="about-mission-container__inner">
          <div className="about-mission-container__content">
            <h2 className="about-mission-container__title">{t('aboutPage.mission.title')}</h2>
            <p>{t('aboutPage.mission.text1')}</p>
            <p>{t('aboutPage.mission.text2')}</p>
            <p>{t('aboutPage.mission.text3')}</p>
            <ul className="about-mission-container__list">
              <li>{t('aboutPage.mission.listItem1')}</li>
              <li>{t('aboutPage.mission.listItem2')}</li>
              <li>{t('aboutPage.mission.listItem3')}</li>
              <li>{t('aboutPage.mission.listItem4')}</li>
            </ul>
            <p>{t('aboutPage.mission.text4')}</p>
          </div>
          <div className="about-mission-container__image">
            <img src="/unimar-mission-manufacturing.webp" alt="UNIMAR Mission" />
          </div>
        </div>
      </section>

      {/* Vision Container */}
      <section className="about-vision-container">
        <div className="about-vision-container__inner">
          <div className="about-vision-container__image">
            <img src="/unimar-vision-manufacturing.webp" alt="UNIMAR Vision" />
          </div>
          <div className="about-vision-container__content">
            <h2 className="about-vision-container__title">{t('aboutPage.vision.title')}</h2>
            <p>{t('aboutPage.vision.text1')}</p>
            <p>{t('aboutPage.vision.text2')}</p>
            <p>{t('aboutPage.vision.text3')}</p>
            <p>{t('aboutPage.vision.text4')}</p>
          </div>
        </div>
      </section>

      {/* Manufacturing Expertise Container */}
      <section className="about-manufacturing-container">
        <div className="about-manufacturing-container__inner">
          <h2 className="about-manufacturing-container__title">{t('aboutPage.manufacturing.title')}</h2>
          <p>{t('aboutPage.manufacturing.text1')}</p>
          <p>{t('aboutPage.manufacturing.text2')}</p>
          <p>{t('aboutPage.manufacturing.text3')}</p>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default About;
